import { GQL } from "@binale-tech/shared";
import type { ReactNode } from "react";

export enum DmsType {
    new_documents = "new_documents",
    uncategorized = "uncategorized",
    Deb = GQL.IProductKey.Deb,
    ER = GQL.IProductKey.Er,
    Bank = GQL.IProductKey.Bank,
    KB = GQL.IProductKey.Kb,
    FE = GQL.IProductKey.Fe,
    POS = GQL.IProductKey.Pos,
    LA = GQL.IProductKey.La,
    taxes = "taxes",
    year_report = "year_report",
    contracts = "contracts",
    company = "company",
    trash = "trash",
}

export interface ITableColumns extends Omit<
    GQL.IDocument,
    | "__typename"
    | "companyId"
    | "externalReference"
    | "key"
    | "previewUrl"
    | "isAttachment"
    | "landCode"
    | "UStIdNr"
    | "color"
    | "isFocused"
> {
    isAttached?: boolean;
    isTransactionAttached?: boolean;
    isCashRegisterAttached?: boolean;
    rowNumber: string;
    actions: ReactNode;
    logs: ReactNode;
    drag: ReactNode;
    documentAmountType: ReactNode;
    vatNumber: string;
    contactClassification: ReactNode;
}

export interface IDocumentType extends GQL.IDmsDocumentType {
    id: DmsType;
    subTypes?: IDocumentSubType[];
}

export interface IDocumentSubType extends GQL.IDmsDocumentSubType {
    dmsDocumentTypeId: DmsType;
}

export type IDocumentSuggestion = Partial<
    Pick<
        GQL.IDocumentUpdateInput,
        | "description"
        | "text2"
        | "documentAmount"
        | "documentNumber"
        | "contactId"
        | "documentDate"
        | "interneNumber"
        | "landCode"
        | "UStIdNr"
    > & {
        currency?: { originalAmount: number; currencyCode: GQL.ICurrencyCode; currencyRate: number };
    }
>;
